import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input, OnInit,
    Output
} from '@angular/core';

/**
 * Simple presenter/dumb component (that essentially could be used - and renamed) other places where similar filter is needed
 */
@Component({
    selector: 'missed-recall-report-filter-component',
    templateUrl: 'missed-recall-report-filter.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./reports.css']
})

export class MissedRecallReportFilterComponent implements OnInit {
    @Input() readonly fromDate: Date;
    @Input() readonly disabled: false;
    @Output() readonly dateChangeEmitter: EventEmitter<Date> = new EventEmitter<Date>(); // TODO: Consider extending to param object if we need to pass more parameters

    maxDateValue: Date;

    ngOnInit(): void {
        this.maxDateValue = new Date();
    }
}
